import { Theme } from '@material-ui/core';

export const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    backgroundColor: '#242737',
    alignItems: 'center',
    borderRadius: '8px',
  },
  open: {
    backgroundColor: '#30354F',
  },
});
